import axios from '../base/axios';
import API_KEY from './key';

const GET_KIDSANDFAMILY = 'flixfrenzy/redux/GET_KIDSANDFAMILY';

// eslint-disable-next-line default-param-last
const kidsAndFamilyReducer = (state = [], action) => {
  switch (action.type) {
    case GET_KIDSANDFAMILY:
      return action.payload;
    default:
      return state;
  }
};

export const getKidsAndFamily = () => (dispatch) => {
  axios.get(`discover/movie?api_key=${API_KEY}&include_adult=false`).then((res) => {
    dispatch({
      type: GET_KIDSANDFAMILY,
      payload: res.data,
    });
  });
};

export default kidsAndFamilyReducer;
